import SageScreen from "kit/SageScreen";
import React from "react";
import BalanceCards from "./balance/BalanceCards";

const Balance: React.FC = () => {
    return (
        <SageScreen>
            <div className="row align-item-center">
                <div className="col">
                    <h2>Balance</h2>
                    <p>
                        This is the balance of your account in minutes and
                        money.
                    </p>
                </div>
            </div>
            <BalanceCards />
        </SageScreen>
    );
};

export default Balance;
